import script from "./Transactions.vue?vue&type=script&setup=true&lang=ts"
export * from "./Transactions.vue?vue&type=script&setup=true&lang=ts"

import "./Transactions.vue?vue&type=style&index=0&id=fbe932cc&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbe932cc"]])

export default __exports__